'use strict';
{
    var app = angular.module('tf.watchlist', [])

        .controller('watchlistCtrl', ['$scope', '$state', '$http', '$filter', '$timeout', 'userConfig', '$q', 'companyService', function watchlistController($scope, $state, $http, $filter, $timeout, userConfig, $q, companyService) {

            function barColour(percent) {
                percent = Math.min(percent, 100);
                percent /= 100;
                return "hsl(" + Math.round(120 * (percent)) + ", 70%, 45%)";
            }

            $scope.goToStrategy = function (entry) {
                if (userConfig.features['SCREEN_STRATEGY_BUILDER']) {
                    $state.go("strategy", {underlying: entry.code});
                }
            };

            $scope.watchlist = null;

            $scope.watchlistHistoryOptions = {
                type:'line',
                width:'140',
                height:'40',
                minSpotColor: "#A90329",
                maxSpotColor: "green",
                fillColor : false,
                lineColor : 'grey',
                lineWidth : 2,
                spotRadius : 2.5,
                spotColor: '#7f7f7f',
                highlightSpotColor: '#333333',
                highlightLineColor: '#333333',
                numberFormatter : function (input) {
                    return '$' + $filter('strike')(input, false);
                }
            };

            $scope.watchlistHistoryOptionsXJO = {
                type:'line',
                width:'140',
                height:'40',
                minSpotColor: "#A90329",
                maxSpotColor: "green",
                fillColor : false,
                lineColor : 'grey',
                lineWidth : 2,
                spotRadius : 2.5,
                spotColor: '#7f7f7f',
                highlightSpotColor: '#333333',
                highlightLineColor: '#333333',
                numberFormatter : function (input) {
                    return $filter('points')(input);
                }
            };

            function reloadWatchlist() {
                $http.get('/tradefloor/api/watchlists/adviser', {}).then(function(response) {

                    var codeExchanges = response.data;
                    var portfolioCodes = codeExchanges.map((c) => c.code);

                    portfolioCodes.push('XJO');

                    var allCodes = userConfig.watchlist.concat(portfolioCodes).sort();

                    $http.post('/tradefloor/api/watchlist/prices', new Set(allCodes)).then(function(response) {
                        var data = response.data;

                        $scope.watchlist = {
                            asAt : data.asAt,
                            entries : [],
                            entriesByCode : {}
                        };

                        for (var i = 0; i < data.prices.length; i++) {
                            var result = data.prices[i];
                            var change = result.price - result.closePrice;
                            var changePct = result.price != 0 ? change / result.closePrice : 0;


                            var watchlistEntry = {
                                code : result.code,
                                price : result.price,
                                closePrice : result.closePrice,
                                change : change,
                                absChange : Math.abs(change),
                                changePct : Math.abs(changePct),
                                points : result.code === 'XJO',
                                yearLow : result.yearLow,
                                yearHigh : result.yearHigh,
                                history : [],
                                systemDefined : portfolioCodes.indexOf(result.code) >= 0,
                                userDefined : userConfig.watchlist.indexOf(result.code) >= 0

                            };

                            watchlistEntry.normalRange = watchlistEntry.yearHigh - watchlistEntry.yearLow;
                            watchlistEntry.normalPrice = watchlistEntry.price - watchlistEntry.yearLow;
                            watchlistEntry.priceRangePct = (watchlistEntry.normalPrice / watchlistEntry.normalRange) * 100;

                            watchlistEntry.barColour = barColour(watchlistEntry.priceRangePct);

                            $scope.watchlist.entries.push(watchlistEntry);
                            $scope.watchlist.entriesByCode[watchlistEntry.code] = watchlistEntry;

                        }

                        $scope.watchlist.entries.sort(function (a, b) {
                            if (a.code == 'XJO') {
                                return -1;
                            }

                            if (b.code == 'XJO') {
                                return 1;
                            }

                            if (a.changePct > b.changePct) {
                                return -1;
                            }

                            if (a.changePct < b.changePct) {
                                return 1;
                            }

                            return 0;
                        });
                        $http.post('/tradefloor/api/watchlist/priceGraph', allCodes).then(function(response) {
                            var data = response.data;
                            $scope.watchlist.entries.forEach(function(watchlistEntry){
                                watchlistEntry.history = [];
                            });
                            data.forEach(function(pricePoint){
                                $scope.watchlist.entriesByCode[pricePoint.code].history.push(pricePoint.price);
                            });
                        });

                    });

                });
            }

            reloadWatchlist();


            $http.get('/tradefloor/api/watchlist/movers', {}).then(function(response) {
                var data = response.data;
                var codes = data;

                $http.post('/tradefloor/api/watchlist/prices', codes).then(function(response) {
                    var data = response.data;

                    $scope.topMoversWatchlist = {
                        asAt : data.asAt,
                        entries : [],
                        entriesByCode : {}
                    };

                    $scope.bottomMoversWatchlist = {
                        asAt : data.asAt,
                        entries : [],
                        entriesByCode : {}
                    };

                    for (var i = 0; i < data.prices.length; i++) {
                        var result = data.prices[i];
                        var change = result.price - result.closePrice;
                        var changePct = result.price != 0 ? change / result.closePrice : 0;


                        var watchlistEntry = {
                            code : result.code,
                            price : result.price,
                            closePrice : result.closePrice,
                            change : change,
                            absChange : Math.abs(change),
                            changePct : Math.abs(changePct),
                            points : result.code === 'XJO',
                            yearLow : result.yearLow,
                            yearHigh : result.yearHigh,
                            history : []

                        };

                        watchlistEntry.normalRange = watchlistEntry.yearHigh - watchlistEntry.yearLow;
                        watchlistEntry.normalPrice = watchlistEntry.price - watchlistEntry.yearLow;
                        watchlistEntry.priceRangePct = (watchlistEntry.normalPrice / watchlistEntry.normalRange) * 100;

                        watchlistEntry.barColour = barColour(watchlistEntry.priceRangePct);

                        if (watchlistEntry.change > 0){
                            $scope.topMoversWatchlist.entries.push(watchlistEntry);
                            $scope.topMoversWatchlist.entriesByCode[watchlistEntry.code] = watchlistEntry;
                        } else {
                            $scope.bottomMoversWatchlist.entries.push(watchlistEntry);
                            $scope.bottomMoversWatchlist.entriesByCode[watchlistEntry.code] = watchlistEntry;
                        }

                    }

                    $scope.topMoversWatchlist.entries.sort(byPct);
                    $scope.bottomMoversWatchlist.entries.sort(byPct);

                    function byPct(a,b) {
                        if (a.changePct > b.changePct) {
                            return -1;
                        }

                        if (a.changePct < b.changePct) {
                            return 1;
                        }

                        return 0;
                    }

                    $http.post('/tradefloor/api/watchlist/priceGraph', codes).then(function(response) {
                        var data = response.data;
                        $scope.pricePoints = data;
                        $scope.updateHistory();
                    });

                    $scope.updateHistory = function(list) {
                        $timeout(function(){
                            $scope.topMoversWatchlist.entries.forEach(function(watchlistEntry){
                                watchlistEntry.history = [];
                            });
                            $scope.bottomMoversWatchlist.entries.forEach(function(watchlistEntry){
                                watchlistEntry.history = [];
                            });
                            $scope.pricePoints.forEach(function(pricePoint){
                                if ($scope.topMoversWatchlist.entriesByCode[pricePoint.code]) {
                                    $scope.topMoversWatchlist.entriesByCode[pricePoint.code].history.push(pricePoint.price);
                                } else if ($scope.bottomMoversWatchlist.entriesByCode[pricePoint.code]) {
                                    $scope.bottomMoversWatchlist.entriesByCode[pricePoint.code].history.push(pricePoint.price);
                                }
                            });
                        }, 0);
                    }

                });

            });
        }]);
}
